import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
  Chip,
} from "@mui/material";
import {
  School as SchoolIcon,
  Person as PersonIcon,
  Group as GroupIcon,
  CheckCircle as CheckIcon,
} from "@mui/icons-material";
import { FormattedMessage } from "react-intl";

// Navigation items configuration
export const navigationItems = [
  {
    id: 'my-teachings',
    label: 'courses-nav.tuition-offered',
    icon: <SchoolIcon />,
    path: '/profile/my-teachings',
    available: true,
  },
  {
    id: 'my-groups',
    label: 'your-content-nav-bar.your-study-groups',
    icon: <GroupIcon />,
    path: '/profile/my-groups',
    available: false,
    comingSoon: true,
  },
  {
    id: 'edit',
    label: 'edit-user-data-profile',
    icon: <PersonIcon />,
    path: '/profile/edit',
    available: true,
  },
];

export const ProfileNavigation = ({ 
  isMobile, 
  selectedArea, 
  onNavigation 
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ 
      width: isMobile ? '100%' : 280, 
      height: '100%',
      maxWidth: isMobile ? '100%' : 280,
      overflow: 'hidden',
      boxSizing: 'border-box',
    }}>
      <Box sx={{ 
        p: { xs: 2, sm: 3 }, 
        borderBottom: 1, 
        borderColor: 'divider',
        pt: isMobile ? 6 : 3, // Add top padding on mobile for status bar
        boxSizing: 'border-box'
      }}>
        <Typography 
          variant="h5" 
          fontWeight="bold" 
          color="text.primary"
          sx={{
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          <FormattedMessage id="header.menu-edit-profile" />
        </Typography>
      </Box>
      
      <List sx={{ pt: 2, overflow: 'hidden' }}>
        {navigationItems.map((item) => {
          const isSelected = selectedArea === `profile/${item.id}` || 
            (selectedArea === "profile" && item.id === "my-teachings");
          
          return (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                selected={isSelected}
                onClick={() => onNavigation(item)}
                sx={{
                  mx: isMobile ? 1 : 1,
                  my: isMobile ? 0.5 : 0,
                  borderRadius: 1,
                  minHeight: isMobile ? 56 : 48,
                  width: 'calc(100% - 16px)', // Ensure it doesn't overflow
                  boxSizing: 'border-box',
                  '&.Mui-selected': {
                    backgroundColor: 'primary.main',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    },
                    '& .MuiListItemIcon-root': {
                      color: 'white',
                    },
                  },
                }}
              >
                <ListItemIcon sx={{ 
                  minWidth: isMobile ? 48 : 40,
                  flexShrink: 0
                }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={
                    <Typography 
                      variant={isMobile ? "h6" : "body1"} 
                      fontWeight={isMobile ? 500 : 400}
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        minWidth: 0
                      }}
                    >
                      <FormattedMessage id={item.label} />
                    </Typography>
                  }
                  secondary={item.comingSoon ? (
                    <Chip 
                      label={<FormattedMessage id="coming-soon" defaultMessage="Coming Soon" />}
                      size="small" 
                      color="warning" 
                      variant="outlined"
                      sx={{ fontSize: '0.75rem' }}
                    />
                  ) : null}
                  sx={{ minWidth: 0, overflow: 'hidden' }}
                />
                {isSelected && (
                  <CheckIcon 
                    sx={{ 
                      ml: 1, 
                      fontSize: isMobile ? 28 : 24,
                      flexShrink: 0
                    }} 
                  />
                )}
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};
